import { combineReducers } from 'redux';

import { uid } from 'Core/Utils';
import { sessionSave as save, sessionLoad as load } from 'Core/Utils/Session';

import UiReducer from 'RLX/State/Ui/UiReducer';
import AuthReducer from 'RLX/State/Auth/AuthReducer';
import ContentReducer from 'RLX/State/Content/ContentReducer';

export default combineReducers({
  ui: UiReducer,
  auth: AuthReducer,
  siteData: ContentReducer
});



// WEBPACK FOOTER //
// ./client/RLX/State/Reducers.js